(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  class FeaturedCollectionScroll extends HTMLElement {
    connectedCallback() {
      this._loading = false;
      this._observer = null;
      this.sentinel = this.querySelector('.featured-collection__sentinel');
      if (!this.sentinel) return;
      

      this.grid = this.querySelector('.product-grid');
      this.footer = this.querySelector('.featured-collection__infinite-footer');

      this._observe();
    }

    disconnectedCallback() {
      if (this._observer) {
        this._observer.disconnect();
      }
    }

    _observe() {
      this._observer = new IntersectionObserver((entries) => this._onIntersect(entries), {rootMargin: '300px'});
      this._observer.observe(this.sentinel);
    }

    _onIntersect(entries) {
      const entry = entries[0];
      if (! entry.isIntersecting || this._loading) return;
      
      this._loadMore();
    }

    async _loadMore() {
      const url = this.sentinel.dataset.nextUrl;
      if (! url || this._loading) return;
      

      this._loading = true;
      this.sentinel.classList.add('featured-collection__sentinel--loading');

      try {
        const response = await fetch(url);
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');

        const newItems = doc.querySelectorAll('.product-grid .grid__item');
        for (const item of newItems) {
          this.grid.appendChild(item);
        }

        const nextSentinel = doc.querySelector('.featured-collection__sentinel');

        if (nextSentinel && nextSentinel.dataset.nextUrl) {
          this.sentinel.dataset.nextUrl = nextSentinel.dataset.nextUrl;
        } else {
          if (this._observer) {
            this._observer.disconnect();
          }
          if (this.footer) {
            this.footer.remove();
          } else {
            this.sentinel.remove();
          }
        }
      } catch (_err) { /* Retry on next intersection */
      }

      this._loading = false;
      this.sentinel.classList.remove('featured-collection__sentinel--loading');
    }
  }

  if (!customElements.get('featured-collection-scroll')) {
    customElements.define('featured-collection-scroll', FeaturedCollectionScroll);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  class CollectionInfiniteScroll extends HTMLElement {
    #loading = false;
    #observer = null;

    connectedCallback() {
      this.sentinel = this.querySelector('.collection-scroll__sentinel');
      if (!this.sentinel) return;

      this.grid = this.querySelector('#product-grid');
      this.#observe();
    }

    disconnectedCallback() {
      this.#observer?.disconnect();
    }

    #observe() {
      this.#observer = new IntersectionObserver(
        (entries) => this.#onIntersect(entries),
        { rootMargin: '300px' }
      );
      this.#observer.observe(this.sentinel);
    }

    #onIntersect(entries) {
      const entry = entries[0];
      if (!entry.isIntersecting || this.#loading) return;
      this.#loadMore();
    }

    async #loadMore() {
      const url = this.sentinel.dataset.nextUrl;
      if (!url) return;

      this.#loading = true;
      this.sentinel.classList.add('collection-scroll__sentinel--loading');

      try {
        const response = await fetch(url);
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');

        const newItems = doc.querySelectorAll('#product-grid .grid__item');
        for (const item of newItems) {
          this.grid.appendChild(item);
        }

        const nextSentinel = doc.querySelector('.collection-scroll__sentinel');

        if (nextSentinel) {
          this.sentinel.dataset.nextUrl = nextSentinel.dataset.nextUrl;
        } else {
          this.#observer.disconnect();
          this.sentinel.remove();
        }
      } catch {
        // Silent fail — sentinel remains, will retry on next scroll into view
      }

      this.#loading = false;
      this.sentinel.classList.remove('collection-scroll__sentinel--loading');
    }
  }

  customElements.define('collection-infinite-scroll', CollectionInfiniteScroll);

  } catch(e) { console.error(e); }
})();
})();
